import { useState, useEffect, useRef } from "react";
import FormBasicInfoSelect from "./formBasicInfoSelect";
import FormBasicInfoInput from "./formBasicInfoInput";
import { ButtonGeneric } from "../ButtonGeneric/buttonGeneric";
import "./formBasicInfo.css";
import {
  getSession,
  getProducts,
  getFavorite,
  getDesFavorite,
  getCenter,
} from "../../redux/actions/fluxoNSimilar";
import FormBasicInfoInputFavorite from "./formBasicInfoInputFavorite";
import { clearStatus, setStatus } from "../../redux/slices/sessionSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import ContainerError from "../error/containerError";
import IconAlert from "../../assets/svgs/icon-alert.svg";
import IconStarSelect from "../../assets/svgs/starSelect.svg";
import IconstartYellow from "../../assets/svgs/startYellow.svg";
import flag from "../../assets/svgs/flag.svg";
import IconStar from "../../assets/svgs/star.svg";
import IconStarDefault from "../../assets/svgs/StarDefault.svg";
import { SelectChangeEvent, Skeleton } from "@mui/material";
import Modal from "../modalCustom/modal";
import ModalFavorite from "../modalFavorite/modalFavorite";
import IconAnswer from "../iconeAnswer/iconAnswer";
import { unwrapResult } from "@reduxjs/toolkit";
import formBasicInfoUtils from "../../utils/statusClassications/formBasicInfoUtils";
import {
  clearProducts,
  selectProduct,
} from "../../redux/slices/sessionProductsSlice";
import UploadImage from "../fluxo-engenheiro/uploadImage/uploadImage";
import { useNotification } from "../../hooks/useNotification";
import Notification from "../fluxo-tax/Notification/notification";
import Textnotifications from "../../utils/notifications";

interface FormBasicInfoProps {
  setQuestionsTrue: React.Dispatch<React.SetStateAction<boolean>>;
  setOriginalQuestions: React.Dispatch<React.SetStateAction<any[]>>;
  setGetPartNumber: React.Dispatch<React.SetStateAction<string>>;
  timeStamp: () => void;
  setPnSimilarSelect: any;
  pnSimilarSelect: any;
  setIsBanner: any;
}

interface Item {
  searchKey: string;
  type: any;
  ncmCode: string;
  partNumber: string;
  nickname: string;
  name: string;
}

export const HighlightedText = ({
  text,
  highlight,
}: {
  text: string;
  highlight: string;
}) => {
  const MAX_LENGTH = 35;
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isHovered, setIsHovered] = useState(false);
  const [position, setPosition] = useState<{ top: number; left: number }>({
    top: 0,
    left: 0,
  });

  const plainTextTruncated =
    text.length > MAX_LENGTH ? text.slice(0, MAX_LENGTH) + "..." : text;

  const escapeRegex = (str: string) =>
    str.replaceAll(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const applyHighlight = (input: string) => {
    const escapedHighlight = escapeRegex(highlight);
    const parts = input.split(new RegExp(`(${escapedHighlight})`, "gi"));

    let uniqueCounter = 0;

    return parts.map((part) => {
      const key = `${part}-${uniqueCounter++}`;

      return part.toLowerCase() === highlight.toLowerCase() ? (
        <strong key={key}>{part}</strong>
      ) : (
        <span key={key}>{part}</span>
      );
    });
  };

  const handleMouseEnter = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPosition({ top: rect.bottom - 40, left: rect.left + 240 });
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          margin: 0,
          display: "inline-block",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "290px",
          verticalAlign: "bottom",
          cursor: "default",
        }}
      >
        {applyHighlight(plainTextTruncated)}
      </button>

      {isHovered && text.length > MAX_LENGTH && (
        <div
          style={{
            position: "fixed",
            top: position.top,
            left: position.left - 200,
            backgroundColor: "#ffffff",
            color: "#000000",
            padding: "10px 10px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
            zIndex: 9999,
            whiteSpace: "nowrap",
            fontSize: "0.875rem",
            pointerEvents: "none",
          }}
        >
          {text}
        </div>
      )}
    </>
  );
};

const FormBasicInfo = ({
  setQuestionsTrue,
  setOriginalQuestions,
  setGetPartNumber,
  setPnSimilarSelect,
  pnSimilarSelect,
  setIsBanner,
}: FormBasicInfoProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const [materialPartNumber, setMaterialPartNumber] = useState("");
  const [materialPartDesc, setMaterialPartDesc] = useState("");
  const [materialPartCenter, setMaterialPartCenter] = useState("");
  const [pnSimilar, setPnSimilar] = useState("");
  const [pnSimilarError, setPnSimilarError] = useState("");
  const [materialPartNumberError, setMaterialPartNumberError] = useState("");
  const [materialPartDescError, setMaterialPartDescError] = useState("");
  const [materialPartCenterError, setMaterialPartCenterError] = useState("");
  const [materialPartFavError, setMaterialPartFavError] = useState("");
  const [errorApi, setErrorApi] = useState(false);
  const [displayLoading, setDisplayLoading] = useState(false);
  const [, setModalDisplay] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [inputSearch, setInputSearch] = useState<any>("");
  const [filterSearch, setFilterSearch] = useState<Item[]>([]);
  const [getStatusFavorite, setGetStatusFavorite] = useState<string>("initial");
  const [getSessionId, setGetSessionId] = useState<any>("");
  const [deleteDisabled, setDeleteDisabled] = useState<boolean>(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(true);
  const [disable, setDisable] = useState(true);
  const [hasSelectedAutocomplete, setHasSelectedAutocomplete] = useState(false);
  const [, setSelectItem] = useState(false);
  const searchContainerRef = useRef<HTMLDivElement>(null);
  const [selectItemError, setSelectItemError] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [imageApiError, setImageApiError] = useState(false);
  const [hasSelected, setHasSelected] = useState(false);

  const [dropdownList, setDropdownList] = useState<string[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const { notification, labelNotification, backgroundColor, showNotification, setNotification } = useNotification();

  const { sessionProducts, sessionProductsSelect } = useSelector(
    (state: RootState) => state.sessionProducts,
  );

  const { sessionCenterSelect } = useSelector(
    (state: RootState) => state.sessionCenter,
  );

  const { sessionFavorite } = useSelector(
    (state: RootState) => state.sessionFavorite,
  );

  const { sessionVerify, httpStatus } = useSelector(
    (state: RootState) => state.sessionInfo,
  );

  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        if (showDropdown) {
          setShowDropdown(false);
          if (!hasSelected) {
            setMaterialPartCenterError("Selecione um item");
          }
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDropdown, hasSelected]);

  useEffect(() => {
    dispatch(getFavorite());
    localStorage.removeItem("getId");
  }, []);

  useEffect(() => {
    if (sessionProducts?.length > 0 && inputSearch?.length != 0) {
      mapSessionProduct();
      setMaterialPartFavError("");
    }
  }, [sessionProducts]);

  useEffect(() => {
    const fetchProducts = async () => {
      if (inputSearch.length >= 3) {
        await dispatch(getProducts({ id: inputSearch }));
      }
    };

    if (!inputSearch || inputSearch.length === 0) {
      setGetStatusFavorite("initial");
      return;
    }
    if (httpStatus === 200 && pnSimilarSelect !== "Não") {
      setIsBanner(true);
    }
    fetchProducts();
  }, [inputSearch, httpStatus, pnSimilarSelect]);

  useEffect(() => {
    if (!sessionProducts || sessionProducts.length === 0) {
      setFilterSearch([]);
    }
  }, [sessionProducts]);
  const mapSessionProduct = () => {
    const newFilter = sessionProducts
      .flatMap((item: any) => {
        const matches: any[] = [];

        if (
          item.nickname &&
          item.nickname.toLowerCase().startsWith(inputSearch.toLowerCase())
        ) {
          matches.push({
            ...item,
            searchKey: item.nickname,
            type: "nickname",
          });
        } else if (
          item.partNumber &&
          item.partNumber.toLowerCase().startsWith(inputSearch.toLowerCase())
        ) {
          matches.push({
            ...item,
            searchKey: item.partNumber,
            type: "partNumber",
          });
        }

        return matches;
      })
      .slice(0, 15);

    setFilterSearch(newFilter);
  };
  const handleDelete = async () => {
    setDeleteDisabled(true);
    try {
      await dispatch(getDesFavorite(getSessionId.id));
      await dispatch(getFavorite());
      setGetStatusFavorite("favorite");
      setIsAlertOpen(false);
      const displayValue =
        getSessionId.partNumber ||
        getSessionId.productCode ||
        getSessionId.nickname;

      setInputSearch(displayValue);
      setPnSimilar(displayValue);
    } catch (error) {
    } finally {
      setDeleteDisabled(false);
    }
  };

  const handleFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    setErrorApi(false);
    const value = event?.target.value.trim();
    setInputSearch(value);
    setGetStatusFavorite("initial");
    setIsDropdownOpen(true);

    if (value.length < 3) {
      setFilterSearch([]);
      return;
    }

    if (!sessionProducts || sessionProducts.length === 0) {
      setFilterSearch([]);
      return;
    }

    if (value.length >= 3) {
      setIsDropdownOpen(true);
      mapSessionProduct();
    }
  };

  const handleFilterFavorite = () => {
    setErrorApi(false);
    const newFilter = sessionFavorite
      ?.flatMap((item: any) => {
        const matches: any[] = [];

        if (
          item.nickname &&
          item.nickname.toLowerCase().startsWith(inputSearch.toLowerCase())
        ) {
          matches.push({
            ...item,
            searchKey: item.nickname,
            type: "nickname",
          });
        }

        return matches;
      })
      .slice(0, 15);

    if (!sessionFavorite || sessionFavorite.length === 0) {
      setFilterSearch(newFilter);
      return;
    }
    setFilterSearch(newFilter);
  };

  function handleClickAutoComplete(value: any) {
    dispatch(selectProduct(value));
    setSelectItem(false);
    setIsDropdownOpen(false);
    handleStarFavorite(value);
    const displayValue =
      value.nickname || value.partNumber || value.productCode;
    setInputSearch(displayValue);
    setPnSimilar(displayValue);
    setFilterSearch([]);
    setMaterialPartFavError("");

    const favoriteMatch = sessionFavorite?.find(
      (fav: any) =>
        fav.nickname === value.nickname ||
        fav.partNumber === value.partNumber ||
        fav.productCode === value.productCode,
    );

    if (favoriteMatch) {
      setGetSessionId(favoriteMatch);
      setGetStatusFavorite("unfavorite");
    } else {
      setGetSessionId(value);
      setGetStatusFavorite("favorite");
    }
  }

  function handleStarFavorite(value: any) {
    const isFavorite = sessionFavorite?.some(
      (fav: any) =>
        fav.nickname === value.nickname ||
        fav.partNumber === value.partNumber ||
        fav.productCode === value.productCode,
    );

    setGetSessionId(value);
    setGetStatusFavorite(isFavorite ? "unfavorite" : "favorite");
  }

  function getDateWithTimezoneOffset() {
    const date = new Date();
    const timezoneOffset = -3;
    const localDate = new Date(
      date.getTime() + timezoneOffset * 60 * 60 * 1000,
    );
    return localDate.toISOString();
  }

  const { sessionInfo, error } = useSelector(
    (state: RootState) => state.sessionInfo,
  );

  const wait = useSelector((state: RootState) => state.sessionInfo.status);

  const MAX_LENGTH = 50;

  const displayQuestions = () => {
    setQuestionsTrue(wait === "ready");
    setErrorApi(!!error);
    setModalDisplay(true);
    if (wait === "error") {
      setDisplayLoading(false);
    }
    setOriginalQuestions(sessionInfo.message);
    setGetPartNumber(
      localStorage.getItem("getId")
        ? localStorage.getItem("getId")
        : getSessionId?.productId,
    );
  };

  useEffect(() => {
    displayQuestions();
  }, [wait, displayLoading]);

  useEffect(() => {
    setMaterialPartNumber(
      sessionVerify?.infosGrid !== null
        ? sessionVerify?.infosGrid?.pnNumberCode
        : materialPartNumber,
    );
    setMaterialPartDesc(
      sessionVerify?.infosGrid !== null
        ? sessionVerify?.infosGrid?.description
        : materialPartDesc,
    );
  }, [sessionVerify?.infosGrid]);

  const handleMaterialPartNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    const caracteres = /[%#&?/]/;

    if (value.length === MAX_LENGTH) {
      setMaterialPartNumberError("Limite de 50 caracteres atingido.");
    } else if (caracteres.test(value)) {
      setMaterialPartNumberError("Caractere inválido. Por favor, corrija.");
    } else {
      setMaterialPartNumberError("");
      dispatch(clearStatus());
    }

    setErrorApi(false);
    setMaterialPartNumber(value);
  };

  const handleMaterialPartDescChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;

    value.length === MAX_LENGTH
      ? setMaterialPartDescError("Limite de 50 caracteres atingido.")
      : setMaterialPartDescError("");

    setErrorApi(false);
    setMaterialPartDesc(event.target.value);
  };

  const handlePnSimilarChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    dispatch(clearProducts());
    const value = event.target.value;

    if (value.length === MAX_LENGTH) {
      setPnSimilarError("Limite de 50 caracteres atingido.");
      setMaterialPartFavError("");
    } else {
      setPnSimilarError("");
      setMaterialPartFavError("");
    }

    setGetSessionId(value);
    setPnSimilar(value);
    setErrorApi(false);
  };

  const handlePnSimilarSelectChange = (
    event: SelectChangeEvent<string>
  ) => {
    const value = event.target.value;

    setPnSimilarSelect(value);
    localStorage.setItem("selectValue", value);

    if (value === "Não") {
      clearFavoriteState();
    }
  };

  const clearFavoriteState = () => {
    setPnSimilar("");
    setInputSearch("");
    setFilterSearch([]);
    setGetStatusFavorite("initial");
    setHasSelectedAutocomplete(false);

    setSelectItemError(false);
    setMaterialPartFavError("");
    setErrorApi(false);

    dispatch(clearProducts());
  };

  useEffect(() => {
    setPnSimilarSelect("Sim");
  }, []);

  useEffect(() => {
    const cond1 =
      (httpStatus === 409 || httpStatus === 404) &&
      (error.message.includes("Classification is already") ||
        error.message.includes("A classificação "));

    const cond2 =
      httpStatus === 409 ||
      (httpStatus === 404 &&
        error.message.includes("An open session for that product was found"));

    if (cond1 || cond2) {
      dispatch(
        setStatus({
          httpStatus: 409,
          message: "A classificação está em andamento ou em revisão.",
        }),
      );
      setDisable(true);
    }

    if (error?.message?.toLowerCase().includes("center not found")) {
      setMaterialPartCenterError("Centro não encontrado");
    }

    if (
      httpStatus === 422 &&
      error?.message?.includes("This new center cannot")
    ) {
      setMaterialPartNumberError(
        "Este PN já possui classificação; não é permitido criar novo centro.",
      );
    }
  }, [httpStatus, dispatch, error]);

  const isCommonFieldsValid = () => {
    return (
      materialPartNumber !== "" &&
      materialPartDesc !== "" &&
      materialPartNumberError === ""
    );
  };

  const isFormValid = () => {
    if (!isCommonFieldsValid()) return false;

    if (pnSimilarSelect === "Sim") {
      return hasSelectedAutocomplete;
    }

    if (pnSimilarSelect === "Não") {
      return true;
    }

    return false;
  };

  const isFormValidRedux = () => {
    if (
      sessionVerify?.infosGrid?.pnNumberCode === null ||
      !isCommonFieldsValid()
    ) {
      return false;
    }

    if (pnSimilarSelect === "Sim") {
      return hasSelectedAutocomplete;
    }

    if (pnSimilarSelect === "Não") {
      return true;
    }

    return false;
  };

  useEffect(() => {
    const hasSavedCenter = localStorage.getItem("selectedCenterForm") !== "";
    let shouldDisable =
      !isFormValid() ||
      !isFormValidRedux() ||
      sessionProductsSelect === null ||
      sessionCenterSelect === null ||
      errorApi ||
      hasSavedCenter;

    if (
      pnSimilarSelect === "Sim" &&
      pnSimilar !== "" &&
      isFormValid() &&
      isFormValidRedux() &&
      sessionProductsSelect !== null &&
      !pnSimilarError &&
      !materialPartFavError &&
      !selectItemError &&
      !errorApi
    ) {
      shouldDisable = false;
    }

    if (
      pnSimilarSelect === "Não" &&
      hasSavedCenter &&
      !errorApi
    ) {
      shouldDisable = false;
    }

    if (
      pnSimilarSelect === "Não" &&
      materialPartNumber !== "" &&
      materialPartDesc !== "" &&
      materialPartCenter !== "" &&
      !materialPartNumberError &&
      !materialPartCenterError &&
      !pnSimilar &&
      !errorApi
    ) {
      shouldDisable = false;
    }

    setDisable(shouldDisable);
  }, [
    pnSimilarSelect,
    materialPartNumber,
    materialPartDesc,
    pnSimilar,
    pnSimilarError,
    materialPartCenter,
    materialPartCenterError,
    materialPartNumberError,
    materialPartFavError,
    selectItemError,
    sessionVerify?.infosGrid?.pnNumberCode,
    hasSelectedAutocomplete,
    sessionProductsSelect,
    sessionCenterSelect,
    errorApi,
    selectedFiles.length,
    localStorage.getItem("selectedCenterForm"),
  ]);

  const previousFilesLength = useRef(selectedFiles.length);

  useEffect(() => {
    const filesChanged = previousFilesLength.current !== selectedFiles.length;
    previousFilesLength.current = selectedFiles.length;

    if (filesChanged && imageApiError) {
      setImageApiError(false);
      setErrorApi(false);
      dispatch(clearStatus());
    }
  }, [dispatch, imageApiError, selectedFiles.length]);

  useEffect(() => {
    setDisable(
      !isFormValid() ||
        !isFormValidRedux() ||
        filterSearch.length > 0 ||
        errorApi,
    );
  }, [hasSelectedAutocomplete]);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);

        if (
          (pnSimilar.trim().length > 0 && !hasSelectedAutocomplete) ||
          (pnSimilar.trim().length > 0 && sessionProductsSelect === null)
        ) {
          setSelectItemError(true);
        } else {
          setSelectItemError(false);
        }
      }
    }

    if (pnSimilarSelect === "Sim") {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pnSimilar, hasSelectedAutocomplete, pnSimilarSelect]);

  const handleMaterialCenterChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = e.target.value;
    setMaterialPartCenter(value);
    setMaterialPartCenterError("");
    setHasSelected(false);

    if (value.length >= 3) {
      try {
        const res = await dispatch(getCenter({ id: value })).unwrap();
        if (res && res.length > 0) {
          setDropdownList(res);
          setShowDropdown(true);
        } else {
          setDropdownList([]);
          setShowDropdown(false);
        }
      } catch {
        setMaterialPartCenterError("Erro ao buscar centro");
      }
    } else {
      setDropdownList([]);
      setShowDropdown(false);
    }
  };

  const handleSelectCenter = (center: string) => {
    setMaterialPartCenter(center);
    localStorage.setItem("selectedCenterForm", center);
    setShowDropdown(false);
    setHasSelected(true);
    setMaterialPartCenterError("");
  };

  const raw = localStorage.getItem("selectedCenterForm");

  const savedCenter =
    raw && raw !== "N/A" && raw !== "[]" && raw !== "" ? raw : "";

  const handleSelectAutocomplete = (value: any) => {
    setDisable(false);
    handleClickAutoComplete(value);
    setHasSelectedAutocomplete(true);
    setSelectItemError(false);
    setErrorApi(false);
  };

  const favoriteCenter = getSessionId?.center || "";

  const apiError = (errorMessage: any) => {
    if (errorMessage.includes("application/octet-stream")) {
      showNotification(
        Textnotifications.getArquivoInvalidoError(),
        "#FFD9D9"
      )
    } else {
      showNotification(
        errorMessage,
        "#FFD9D9"
      )
    }
  }


  return (
    <>
      {displayLoading && (
        <>
          <div style={{ padding: "35px 0 0 35px" }}>
            <div style={{ marginTop: 20 }}>
              <Skeleton variant="rectangular" width={310} height={30} />
              <br />
              <Skeleton variant="rectangular" width={580} height={80} />
              <br />
              <Skeleton variant="rectangular" width={378} height={105} />
              <br />
              <Skeleton variant="rectangular" width={378} height={50} />
              <br />
              <Skeleton variant="rectangular" width={104} height={50} />
              <br />
            </div>
          </div>
        </>
      )}

      {!displayLoading && (
        <div className="containerFormBasic">
          <div
            className="containerSimilar"
            role="form"
            aria-labelledby="form-title"
          >
            <div
              style={{ display: "flex", flexDirection: "column", width: 314 }}
            >
              <FormBasicInfoInput
                id="material-part-number"
                label="Material/Part Number*"
                value={
                  materialPartNumber
                    ? materialPartNumber
                    : sessionVerify?.infosGrid?.pnNumberCode
                }
                maxLength={50}
                disabled={
                  sessionVerify?.infosGrid?.pnNumberCode !== null
                    ? sessionVerify?.infosGrid?.pnNumberCode
                    : materialPartNumber
                }
                onChange={handleMaterialPartNumberChange}
                aria-required="true"
                aria-describedby="Material/Part Number"
              />

              {materialPartNumberError && (
                <ContainerError
                  id="material-part-number-error"
                  label={materialPartNumberError}
                  icon={IconAlert}
                  widthError=""
                  backgroudError={
                    error?.message.includes("This new center cannot")
                      ? "#FFD9D9"
                      : "#D1E4FF"
                  }
                  colorError={"#000000"}
                />
              )}

              {httpStatus === 409 && errorApi && (
                <ContainerError
                  id="material-part-number-error"
                  label="A classificação está em andamento ou em revisão."
                  icon={IconAlert}
                  widthError={"100%"}
                  backgroudError={"#FFD9D9"}
                  colorError={"#000000"}
                />
              )}
            </div>

            <div>
              <FormBasicInfoInput
                id="material-part-desc"
                label="Nome técnico/Descrição*"
                value={
                  materialPartDesc
                    ? materialPartDesc
                    : sessionVerify?.infosGrid?.description
                }
                onChange={handleMaterialPartDescChange}
                aria-required="true"
                aria-describedby="Nome técnico/Descrição"
                maxLength={50}
                disabled={
                  sessionVerify?.infosGrid?.description !== null
                    ? sessionVerify?.infosGrid?.description
                    : ""
                }
              />

              {materialPartDescError && (
                <ContainerError
                  id="material-part-desc-error"
                  label={materialPartDescError}
                  icon={IconAlert}
                  widthError=""
                  backgroudError={"#D1E4FF"}
                  colorError={"#000000"}
                />
              )}
            </div>

            <div ref={wrapperRef} style={{ position: "relative" }}>
              <FormBasicInfoInput
                id="material-part-center"
                label="Centro*"
                value={materialPartCenter || savedCenter}
                maxLength={50}
                disabled={!!savedCenter}
                onChange={handleMaterialCenterChange}
                aria-required="true"
                aria-describedby="Centro"
              />

              {materialPartCenterError && (
                <ContainerError
                  id="material-part-desc-error"
                  label={materialPartCenterError}
                  icon={IconAlert}
                  widthError="314px"
                  backgroudError={
                    error?.message
                      ?.toLowerCase()
                      .includes("center not found") ||
                    error?.message?.includes("This new center cannot")
                      ? "#FFD9D9"
                      : "#D1E4FF"
                  }
                  colorError="#000000"
                />
              )}

              {showDropdown && dropdownList.length > 0 && (
                <div className="dataResult">
                  {dropdownList.map((item: any, index) => (
                    <div
                      key={item.id || index}
                      className="dataItem"
                      onClick={() => handleSelectCenter(item.center)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          handleSelectCenter(item.center);
                        }
                      }}
                      data-id={item.id}
                      tabIndex={0}
                      role="option"
                      aria-selected="false"
                      id={`autocomplete-option-${index}`}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      <p>
                        {item.center}
                        <span style={{ color: "#6b7280" }}>
                          ({item.sap_environment})
                        </span>
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="containerSimilar" role="form" aria-label="form-title">
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <FormBasicInfoSelect
                value={pnSimilarSelect}
                onChange={handlePnSimilarSelectChange}
                label="Existe um Part Number Favorito?*"
                options={[
                  { value: "Sim", label: "Sim" },
                  { value: "Não", label: "Não" },
                ]}
              />
              <div
                style={{ marginRight: "-30px", marginLeft: "7px", zIndex: 1 }}
              >
                <IconAnswer
                  message="O <b>Favorito</b> serve como referência para agilizar a classificação.
                  </br> Se cadastrado via TRAI, reutiliza respostas anteriores; caso contrário, envia-se o NCM como referência."
                />

                <br />
              </div>
            </div>
            {isAlertOpen && (
              <Modal
                titleModal="Aviso"
                titleDescription="Você deseja remover o item dos favoritos?"
                bodyModal="Essa ação vai desfavoritar o item e restaurar seu nome original."
                buttonOne="Sim"
                buttonTwo="Não"
                onConfirm={() => setIsAlertOpen(false)}
                onClose={() => handleDelete()}
                disabled={deleteDisabled}
              />
            )}

            {pnSimilarSelect === "Sim" && (
              <>
                <div className="StarContainer" ref={searchContainerRef}>
                  <div style={{ display: "flex" }}>
                    <FormBasicInfoInputFavorite
                      title={
                        getStatusFavorite === "unfavorite"
                          ? "Desfavoritar"
                          : "Favoritar"
                      }
                      placeholder="Part Number ou Template"
                      isVisible={getStatusFavorite !== "initial"}
                      label="Selecione o Favorito*"
                      value={pnSimilar}
                      img2={flag}
                      img={{
                        default:
                          getStatusFavorite === "unfavorite"
                            ? IconStarSelect
                            : IconStarDefault,
                        hover:
                          getStatusFavorite === "unfavorite"
                            ? IconstartYellow
                            : IconStar,
                      }}
                      onClickFav={() => {
                        if (getStatusFavorite === "favorite") {
                          setIsModalOpen(true);
                        } else {
                          setIsAlertOpen(true);
                        }
                      }}
                      onClick={() => {
                        if (pnSimilar?.length === 0) {
                          handleFilterFavorite();
                        }
                        if (filterSearch.length > 0) {
                          setIsDropdownOpen(true);
                        }
                      }}
                      onChange={(event: any) => {
                        handleFilter(event);
                        handlePnSimilarChange(event);
                        if (pnSimilar.trim().length === 0) {
                          setSelectItemError(false);
                        }
                      }}
                    />
                    <div
                      style={{
                        marginRight: "-30px",
                        marginLeft: "7px",
                        zIndex: 1,
                      }}
                    >
                      <IconAnswer
                        message="Para <b>favoritar</b>, selecione um Part Number,
                      clique no ícone de estrela e preencha com o nome desejado.
                      <br />
                      Para <b>desfavoritar</b>, clique na estrela novamente e
                      confirme."
                      />
                    </div>
                  </div>
                  {materialPartFavError && (
                    <ContainerError
                      id="material-part-desc-error"
                      label={materialPartFavError}
                      icon={IconAlert}
                      widthError={""}
                      backgroudError={"#FFD9D9"}
                      colorError={"#000000"}
                    />
                  )}
                  <div>
                    {isModalOpen && (
                      <ModalFavorite
                        onClose={() => setIsModalOpen(false)}
                        productCode={pnSimilar}
                        setIsModalOpen={setIsModalOpen}
                        setGetStatusFavorite={setGetStatusFavorite}
                        setPnSimilar={setPnSimilar}
                        setFilterSearch={setFilterSearch}
                        setGetSessionId={setGetSessionId}
                        center={favoriteCenter}
                      />
                    )}
                  </div>

                  {pnSimilarError && pnSimilar.trim() !== "" && (
                    <ContainerError
                      id="part-number-similar-error"
                      label={pnSimilarError}
                      icon={IconAlert}
                      widthError={"314px"}
                      backgroudError={"#D1E4FF"}
                      colorError={"#000000"}
                    />
                  )}

                  <div className="search">
                    {isDropdownOpen && filterSearch.length > 0 && (
                      <div className="dataResult">
                        {filterSearch.map((value, index) => (
                          <div
                            key={value.searchKey || index}
                            className="dataItem"
                            onClick={() => {
                              handleSelectAutocomplete(value);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                handleSelectAutocomplete(value);
                              }
                            }}
                            data-id={`${value.type}`}
                            tabIndex={0}
                            role="option"
                            aria-selected="false"
                            id={`autocomplete-option-${index}`}
                          >
                            <p key={value.searchKey}>
                              <HighlightedText
                                text={value.searchKey}
                                highlight={inputSearch}
                              />
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {selectItemError && pnSimilar.length > 0 && (
                    <ContainerError
                      id="material-part-number-error"
                      label="Selecione um item."
                      icon={IconAlert}
                      widthError={"108%"}
                      backgroudError={"#D1E4FF"}
                      colorError={"#000000"}
                    />
                  )}

                  {httpStatus === 404 && errorApi && (
                    <ContainerError
                      id="material-part-number-error"
                      label="NCM inválido, favorito indisponível."
                      icon={IconAlert}
                      widthError={"108%"}
                      backgroudError={"#FFD9D9"}
                      colorError={"#000000"}
                    />
                  )}

                  {httpStatus === 422 &&
                    errorApi &&
                    !error?.message?.includes("This new center cannot") && (
                      <ContainerError
                        id="material-part-number-error"
                        label="Favorito indisponível no momento."
                        icon={IconAlert}
                        widthError={"108%"}
                        backgroudError={"#FFD9D9"}
                        colorError={"#000000"}
                      />
                    )}
                </div>
              </>
            )}
          </div>

          <div style={{ marginTop: "25px" }}>
            <UploadImage
              onFilesSelected={setSelectedFiles}
              setSelectedFiles={setSelectedFiles}
              selectedFiles={selectedFiles}
            />
          </div>

          <div style={{ marginTop: 20, display: "flex" }}>
            <ButtonGeneric
              title="Confirmar"
              colorTitle="#FFFFFF"
              background=""
              style="buttonHeading"
              disabled={disable}
              onClick={async () => {
                try {
                  setDisable(true);
                  setDisplayLoading(true);
                  const formData = new FormData();

                  selectedFiles.forEach((file) => {
                    formData.append("images", file);
                  });

                  const dataPayload = {
                    product: materialPartNumber,
                    description: materialPartDesc,
                    isSimilar: pnSimilarSelect === "Sim",
                    productSimilarId:
                      sessionProductsSelect?.productId ??
                      getSessionId?.productId ??
                      getSessionId?.id,
                    center: materialPartCenter || savedCenter,
                  };

                  formData.append("data", JSON.stringify(dataPayload));
                  const resultAction = await dispatch(getSession(formData));
                  unwrapResult(resultAction);

                  localStorage.setItem("getId", dataPayload.product);
                  displayQuestions();
                  setDisable(false);
                  setDisplayLoading(false);

                  formBasicInfoUtils.handleConfirmClick({
                    pnSimilarSelect,
                    getSessionId,
                    pnSimilar,
                    materialPartNumber,
                    materialPartDesc,
                    sessionVerify,
                    dispatch,
                    setMaterialPartFavError,
                    setDisplayLoading,
                    setGetSessionId,
                    getDateWithTimezoneOffset,
                    setQuestionsTrue,
                    setErrorApi,
                    setModalDisplay,
                    setOriginalQuestions,
                    setGetPartNumber,
                    sessionProducts,
                    setIsBanner,
                  });
                } catch (err: any) {
                  const isFileError =
                    err.message?.includes("application/octet-stream") ||
                    (selectedFiles.length > 0 &&
                      ![404, 409, 422].includes(err.httpStatus));
                  setImageApiError(!!isFileError);
                  apiError(err.message || "Ocorreu um erro. Tente novamente.");
                  console.error("Erro ao iniciar sessão:", err);
                }
              }}
            />
          </div>
        </div>
      )}

      {notification && (
        <div className="AlertImagetPosition">
          <Notification
            classNameAux="justifyText"
            label={labelNotification}
            backgroundError={backgroundColor}
            widthError="385px"
            img={IconAlert}
            setNotification={setNotification}
          />
        </div>
      )}
    </>
  );
};

export default FormBasicInfo;
